import { FreelancerInvoiceSubmissionResource } from '@/types/resources';

export type InvoiceAmountInput = {
  hours: string;
  amount: string;
  payment_purpose: string;
};

export type InvoiceBonusInput = {
  amount: string;
  purpose: string;
};

/**
 * Purpose off a stored amount row. The backend field name isn't settled — the
 * generation form submits `payment_purpose`, some responses come back
 * `paymentPurpose` — so tolerate either.
 */
export const amountPaymentPurpose = (a: {
  paymentPurpose?: string | null;
}): string =>
  a.paymentPurpose ||
  (a as { payment_purpose?: string | null }).payment_purpose ||
  '';

export const isFilledAmount = (li: InvoiceAmountInput): boolean =>
  !!li.amount && !!li.payment_purpose;

export const isFilledBonus = (b: InvoiceBonusInput): boolean => !!b.amount;

export const sumAmounts = (items: { amount: number | string }[]): number =>
  items.reduce((sum, item) => sum + (Number(item.amount) || 0), 0);

export const submissionTotalAmount = (
  s: FreelancerInvoiceSubmissionResource,
): number =>
  s.amounts?.length ? sumAmounts(s.amounts) : Number(s.amount) || 0;

export const submissionTotalBonus = (
  s: FreelancerInvoiceSubmissionResource,
): number =>
  s.bonuses?.length ? sumAmounts(s.bonuses) : Number(s.bonus ?? 0) || 0;

export const prefillAmounts = (
  s?: FreelancerInvoiceSubmissionResource,
): InvoiceAmountInput[] => {
  if (s?.amounts?.length) {
    return s.amounts.map((li) => ({
      hours: li.hours != null ? String(li.hours) : '',
      amount: String(li.amount),
      payment_purpose: li.paymentPurpose ?? '',
    }));
  }
  if (s) {
    return [
      {
        hours: s.hours != null ? String(s.hours) : '',
        amount: String(s.amount),
        payment_purpose: s.paymentPurpose ?? '',
      },
    ];
  }
  return [{ hours: '', amount: '', payment_purpose: '' }];
};

export const prefillBonuses = (
  s?: FreelancerInvoiceSubmissionResource,
): InvoiceBonusInput[] => {
  if (s?.bonuses?.length) {
    return s.bonuses.map((b) => ({
      amount: String(b.amount),
      purpose: b.purpose ?? '',
    }));
  }
  if (s?.bonus != null) {
    return [{ amount: String(s.bonus), purpose: '' }];
  }
  return [{ amount: '', purpose: '' }];
};
